module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/lightbulb-icon-70a117f2b39829583cc6c59fc1b4407c.png";